import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';
import { LocationDetails, UpdateCompanyInfoPayload } from '../models/data-management.model';
import { PagedRequest } from 'common/models/data/pagedRequest.model';

const dataManagementApiConfig = {
    fetchAllCompanyFootprintLocations: (payload: PagedRequest): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.COMPANYFOOTPRINT}/${METHOD.COMPANYFOOTPRINT.COMPANY_LOCATIONS}`,
            ApiMethods.POST,
            '',
            payload
        ),

    fetchCompanyInfo: (): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.COMPANYFOOTPRINT}/${METHOD.COMPANYFOOTPRINT.COMPANY_INFO}`,
            ApiMethods.GET,
            ''
        ),
    updateCompanyInfo: (payload: UpdateCompanyInfoPayload): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.COMPANYFOOTPRINT}/${METHOD.COMPANYFOOTPRINT.UPDATE_COMPANY_INFO}`,
            ApiMethods.POST,
            '',
            payload
        ),

    updateLocationWiseCompanyFootprint: (payload: LocationDetails): ApiConfig =>
        new ApiConfig(
            `${CONTROLLER.COMPANYFOOTPRINT}/${METHOD.COMPANYFOOTPRINT.UPDATE_COMPANY_FOOTPRINT_LOCATION}`,
            ApiMethods.POST,
            '',
            payload
        )
};

export default dataManagementApiConfig;
